export interface ScreenRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

/** Place the complete chip below visible top HUD panels it would cross.
 * All inputs are render pixels, after GUI texture scaling and link offsets.
 */
export function placeCueBelowTopHud(
  center: { x: number; y: number },
  size: { width: number; height: number },
  viewportHeight: number,
  obstacles: readonly ScreenRect[],
): number {
  let minY = viewportHeight * 0.16;
  for (const rect of obstacles) {
    if (center.x + size.width / 2 + 8 <= rect.left ||
        center.x - size.width / 2 - 8 >= rect.left + rect.width) continue;
    minY = Math.max(minY, rect.top + rect.height + 8 + size.height / 2);
  }
  return Math.min(Math.max(center.y, minY), viewportHeight * 0.78);
}
